import { UseQueryOptionsWithoutQueryKey } from '../../react-query-config'
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { useQuery } from '@tanstack/react-query'
import { ResponseApiError } from '../../models/axios-error'

export type DirectorYearlyTrajectoryValues = {
  year: number
  trajectoryGmvValue: number
  progression: number
  validatorUid: string
  validationDate: string
}

export type DirectorYearlyTrajectoriesGmvResponse = {
  directorYearlyTrajectories: DirectorYearlyTrajectoryValues[]
}

const getDirectorYearlyTrajectoriesGmv = async (
  config: AxiosRequestConfig
): Promise<DirectorYearlyTrajectoriesGmvResponse> => {
  const axiosPromise: AxiosResponse<DirectorYearlyTrajectoriesGmvResponse> = await axios(config)
  return {
    ...axiosPromise.data
  }
}

export const useApiGetDirectorYearlyTrajectoriesGmv = (
  storeId: number,
  enabled: boolean,
  options?: UseQueryOptionsWithoutQueryKey<DirectorYearlyTrajectoriesGmvResponse>
) => {
  const url = `/v1/stores/${storeId}/trajectories/gmv`
  const config: AxiosRequestConfig = { method: 'get', url }

  return useQuery<DirectorYearlyTrajectoriesGmvResponse, ResponseApiError>({
    queryKey: ['get-director-yearly-trajectories-gmv', url],
    queryFn: () => getDirectorYearlyTrajectoriesGmv(config),
    enabled,
    ...options
  })
}
